import { func, shape, string } from 'prop-types';
import React, { PureComponent } from 'react';
import { Dialog, Text } from 'reactor/components';
import { THEME } from 'reactor/common';

import { C } from 'common';
import styles from './DialogMessage.style';

const { COLOR } = THEME;
const { MESSAGE: { TYPE } } = C;
let TIMEOUT;

export default class DialogMessage extends PureComponent {
  static propTypes = {
    value: shape({
      text: string,
      title: string,
      type: string,
    }),
    onClose: func.isRequired,
  };

  static defaultProps = {
    value: undefined,
  };

  componentWillReceiveProps({ onClose, value: { text, type } = {} }) {
    clearTimeout(TIMEOUT);
    if (type === TYPE.INFO && text) TIMEOUT = setTimeout(onClose, 4000);
  }

  render() {
    const { value: { text, title, type } = {}, onClose } = this.props;

    return (
      <Dialog
        background={false}
        highlight
        onClose={onClose}
        reverse
        styleContainer={styles.dialogContainer}
        style={[styles.dialog, styles[type]]}
        title={title || type}
        visible={text !== undefined}
      >
        <Text level={3} color={COLOR.WHITE}>{text}</Text>
      </Dialog>
    );
  }
}
